/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  ListReportDealsQueryResponse,
  ListReportDealsQueryParams,
} from '../../types/ListReportDeals'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listReportDeals } from '../../clients/listReportDeals'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listReportDealsQueryKey = (params?: ListReportDealsQueryParams) =>
  [{ url: '/api/v1/reports/deals/' }, ...(params ? [params] : [])] as const

export type ListReportDealsQueryKey = ReturnType<typeof listReportDealsQueryKey>

export function listReportDealsQueryOptions(
  params?: ListReportDealsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = listReportDealsQueryKey(params)
  return queryOptions<
    ListReportDealsQueryResponse,
    ResponseErrorConfig<Error>,
    ListReportDealsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listReportDeals(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @description Paginated, filterable list of deal reports. Query params mirror DealReportFilter (reports/filters/deal_report_filters.py) plus search/sort/pagination; several params ending in `_less`/`_greater` or prefixed `cc_` have V1-compatible aliases noted below.
 * @summary List deal reports
 * {@link /api/v1/reports/deals/}
 */
export function useListReportDeals<
  TData = ListReportDealsQueryResponse,
  TQueryData = ListReportDealsQueryResponse,
  TQueryKey extends QueryKey = ListReportDealsQueryKey,
>(
  params?: ListReportDealsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListReportDealsQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? listReportDealsQueryKey(params)

  const query = useQuery(
    {
      ...listReportDealsQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
